module.exports = __webpack_public_path__ + "static/happy-father-with-his-son-playing-at-home-on-the-PL755ZD-d6d99fc157146aea528365b138822b17.jpg";